import { t } from "i18next";
import toast from "react-hot-toast";
import { Modal } from "ui";

import { useDeleteReseller, useRestoreReseller } from "../../../apis";
import { ChangeResellerDeleteStatusModalProps } from "./ChangeResellerDeleteStatusModal.types";

const ChangeResellerDeleteStatusModal = ({
  isOpen,
  resellerId,
  action,
  onClose
}: ChangeResellerDeleteStatusModalProps) => {
  const deleteReseller = useDeleteReseller({
    onSuccess: () => {
      onClose();
      toast.success(t("User has been  successfully deleted"));
    }
  });

  const restoreReseller = useRestoreReseller({
    onSuccess: () => {
      onClose();
      toast.success(t("User has been  successfully restored"));
    }
  });

  const onOkClick = () => {
    if (action === "Delete") {
      deleteReseller.mutate(String(resellerId));
    } else {
      restoreReseller.mutate(String(resellerId));
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      title={t(`${action} Reseller`)}
      isLoading={deleteReseller.isLoading || restoreReseller.isLoading}
      type={action === "Delete" ? "delete" : "primary"}
      okText={action}
      onOk={onOkClick}
      onClose={onClose}
    >
      <p>
        {t(
          `Are you sure you want to ${action.toLowerCase()} this reseller's account?`
        )}
      </p>
    </Modal>
  );
};

export default ChangeResellerDeleteStatusModal;
